import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import CircleOption from "../../components/filterOption/CircleOption";
import ClearFiltersButton from "../../components/filters/ClearFiltersButton";
import FilterMenu from "../../components/filters/FilterMenu";
import SearchInput from "../../components/filters/SearchInput";

/**
 * Demo component for ClearFiltersButton
 * Shows how it works together with FilterMenu and SearchInput
 */
const ClearFiltersButtonDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({
    status: {},
    priority: {},
    searchString: "",
  });

  // Sample filter options
  const statusOptions = ["Gap", "Compliant", "Snoozed", "Excluded"];
  const priorityOptions = ["Lowest", "Low", "Medium", "High", "Highest"];

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="subtitle2">
        Filter Bar with ClearFiltersButton:
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        flexWrap="wrap"
        alignItems="center"
      >
        {/* Status Filter */}
        <FilterMenu
          filterName="Status"
          fieldName="status"
          options={statusOptions.map((status) => ({
            name: status,
            label: <CircleOption label={status} type="status" />,
            displayName: status,
          }))}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          fullOptions={statusOptions}
        />

        {/* Priority Filter */}
        <FilterMenu
          filterName="Priority"
          fieldName="priority"
          options={priorityOptions.map((priority) => ({
            name: priority,
            label: <CircleOption label={priority} type="priority" />,
            displayName: priority,
          }))}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          fullOptions={priorityOptions}
        />

        {/* Search Input */}
        <Box width={200}>
          <SearchInput
            fieldName="searchString"
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
          />
        </Box>

        {/* Clear Filters Button */}
        <ClearFiltersButton
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
        />
      </Box>

      <Divider />

      <Typography variant="subtitle2">Current Filters:</Typography>
      <Box sx={{ mb: 1 }}>
        {Object.keys(appliedFilters.status).length > 0 && (
          <Box display="flex" alignItems="center" gap={1} mb={0.5}>
            <Typography variant="caption" fontWeight="bold">
              Status:
            </Typography>
            {Object.keys(appliedFilters.status).map((status) => (
              <CircleOption key={status} label={status} type="status" />
            ))}
          </Box>
        )}

        {Object.keys(appliedFilters.priority).length > 0 && (
          <Box display="flex" alignItems="center" gap={1} mb={0.5}>
            <Typography variant="caption" fontWeight="bold">
              Priority:
            </Typography>
            {Object.keys(appliedFilters.priority).map((priority) => (
              <CircleOption key={priority} label={priority} type="priority" />
            ))}
          </Box>
        )}

        {appliedFilters.searchString && (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="caption" fontWeight="bold">
              Search:
            </Typography>
            <Typography variant="caption">
              "{appliedFilters.searchString}"
            </Typography>
          </Box>
        )}

        {Object.keys(appliedFilters.status).length === 0 &&
          Object.keys(appliedFilters.priority).length === 0 &&
          !appliedFilters.searchString && (
            <Typography variant="caption" color="text.secondary">
              No filters applied
            </Typography>
          )}
      </Box>

      <pre
        style={{
          backgroundColor: "#f5f5f5",
          padding: "12px",
          borderRadius: "4px",
          fontSize: "0.8rem",
          overflow: "auto",
        }}
      >
        {JSON.stringify(appliedFilters, null, 2)}
      </pre>
    </Box>
  );
};

export default ClearFiltersButtonDemo;
